module.exports = __webpack_public_path__ + "img/resistor.4d3d7482.svg";